export const getFilterValue = (value) => {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value.value ?? '';
  }
  return value ?? '';
};

export const getFilterValues = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => getFilterValue(item))
      .filter((item) => String(item).trim() !== '');
  }

  const singleValue = getFilterValue(value);
  return String(singleValue).trim() === '' ? [] : [singleValue];
};

export const matchesMultiSelectExact = (fieldValue, filterValue) => {
  const filterValues = getFilterValues(filterValue);
  if (filterValues.length === 0) {
    return true;
  }

  const normalizedField = String(fieldValue ?? '').trim().toLowerCase();
  return filterValues.some(
    (currentValue) => normalizedField === String(currentValue).trim().toLowerCase()
  );
};

export const buildSelectOptionsFromField = (items, fieldName) => {
  const uniqueValues = new Set();

  items.forEach((item) => {
    const value = String(item?.[fieldName] ?? '').trim();
    if (value) {
      uniqueValues.add(value);
    }
  });

  return Array.from(uniqueValues)
    .sort((left, right) => left.localeCompare(right, 'pt-BR'))
    .map((value) => ({ value, label: value }));
};

export const extractMultiSelectApiValues = (filterValue) => getFilterValues(filterValue);

export const applyOptionsToFilters = (filterConfig, optionsByFieldId) => (
  filterConfig.map((filter) => {
    const options = optionsByFieldId[filter.id];
    if (!options) {
      return filter;
    }
    return { ...filter, options };
  })
);

export const mapValuesToSelectOptions = (values) => (
  values
    .filter((value) => String(value ?? '').trim() !== '')
    .map((value) => {
      const normalized = String(value).trim();
      return { value: normalized, label: normalized };
    })
    .sort((left, right) => left.label.localeCompare(right.label, 'pt-BR'))
);
